import ViewerAccessModalContent from "./ViewerAccessModalContent";

export default ViewerAccessModalContent;
